import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class BlowerNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.Blower,
    });
  }
}
